const toTimeUnit = (value: number) => (value < 10 ? `0${value}` : String(value));

export default toTimeUnit;
